import { MantineThemeOverride } from '@mantine/core';

export type StackTheme = NonNullable<MantineThemeOverride['components']>['Stack'];

export const Stack: StackTheme = {
  // todo: define
};
